import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createScaffolderFormDecorator,
  FormDecoratorBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { authorizePersonalCreation } from './authorizePersonalCreation';
import { requestPersonalCreationToken } from './requestPersonalCreationToken';

const personalCreationAuthorization = createScaffolderFormDecorator({
  id: 'personal-github-creation',
  deps: { githubAuth: githubAuthApiRef },
  async decorator(context, { githubAuth }) {
    await authorizePersonalCreation(
      context.formState,
      function requestRepositoryCreationAuthorization() {
        return requestPersonalCreationToken(githubAuth);
      },
      context.setSecrets,
    );
  },
});

export const personalGithubModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormDecoratorBlueprint.make({
      name: 'personal-github-creation',
      params: { decorator: personalCreationAuthorization },
    }),
  ],
});
